import { render, staticRenderFns } from "./ModalPolicyText.vue?vue&type=template&id=212f1a0a"
import script from "./ModalPolicyText.vue?vue&type=script&lang=js"
export * from "./ModalPolicyText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports